import React, {Component} from 'react';
import API from "../../services/API";
import Toast from "../Common/Toast";
import Actionbar from "../Common/Actionbar";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPhoneAlt, faStar as faSolidStar, faTruck} from "@fortawesome/free-solid-svg-icons";
import {toast} from "react-toastify";
import {faStar as faRegularStar} from "@fortawesome/free-regular-svg-icons";

const currencyFormat = Intl.NumberFormat('en-US');

class SelectForRequest extends Component {
    state = {
        drivers: [],
        request: [],
        selected_driver: 0,
        driverName: '',
        selected_driver_name: '',
        driver_share: 0,
        disabled: '',
        driver_share_description: '',
    }
    onSearchDriver = (event) => {
        this.setState({driverName: event.target.value})
        if (event.target.value.length > 2) {
            const request = {
                expert_drivers: true,
                request_id: this.props.match.params.id,
                search_key: event.target.value
            }
            API.getDrivers(request)
                .then((response) => {
                    this.setState({drivers: response.results.drivers, request: response.results.request})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }
        if (event.target.value.length < 1) {
            const request = {
                expert_drivers: true,
                request_id: this.props.match.params.id,

            }
            API.getDrivers(request)
                .then((response) => {
                    this.setState({drivers: response.results.drivers, request: response.results.request})

                })
                .catch((error) => {
                    //   toast.error(error.response.data.user_message);
                });
        }

    }
    onSetDriver = () => {
        this.setState({'disabled': 'disabled'})
        const request = {
            driver_id: this.state.selected_driver,
            driver_share: this.state.driver_share,
            driver_share_description: this.state.driver_share_description,
            request_id: this.props.match.params.id,
        }
        API.setDriver(request)
            .then((response) => {
                toast.success(response.user_message);
                window.location.replace("/request/" + this.props.match.params.id);
/*                setTimeout(() => {
                    window.location.replace("/request/" + this.props.match.params.id);
                }, 1500)*/
            })
            .catch((error) => {
                this.setState({'disabled': ''})
                toast.error(error.response.data.user_message);
            });
    }

    render() {
        return (
            <React.Fragment>
                <Toast/>
                <Actionbar noBack={0} title='انتخاب راننده برای درخواست'/>
                <section className="container mt-4 rtl pt-5 ">
                    <div className="row px-2 border-bottom pb-2">
                        <div className="col-12">
                            <div className="alert alert-success super-small text-center">
                                تخصیص راننده برای درخواست
                                &nbsp;
                                <b>{this.state.request.company}</b>
                                &nbsp;
                                به شماره پیگیری:
                                &nbsp;
                                <b>{this.state.request.tracking_code}</b>
                            </div>
                        </div>
                    </div>


                </section>

                <section className="container px-4 rtl">
                    <div className="row my-3">
                        <div className="col-12">
                            <div className="form-floating super-small-2">
                                <input type="text" className="form-control height-40" id="floatingInput"
                                       placeholder="جستجو  راننده"
                                       onChange={this.onSearchDriver}
                                       value={this.state.driverName}
                                />
                                <label htmlFor="floatingInput">جستجو راننده </label>
                            </div>
                        </div>
                    </div>
                    {
                        this.state.drivers.map(driver => {
                            let dclass = 'row driver-row';
                            if (driver.id === this.state.selected_driver) {
                                dclass = 'row driver-row-selected'
                            }
                            let car_type = '<span class="text-success super-small">تطابق  </span>';
                            if (driver.cars.length > 0 && driver.cars[0].car_type_id !== this.state.request.car_type) {
                                car_type = "<span class='text-danger super-small'> عدم تطابق  </span>";
                            }
                            return (
                                <div className={dclass} key={driver.id}
                                     onClick={() => {
                                         this.setState({
                                             selected_driver: driver.id,
                                             selected_driver_name: driver.full_name
                                         })
                                     }}
                                >
                                    <div className="col-2">
                                        <img src={driver.avatar} alt="avatar" className='w-100 rounded-more'/>
                                        {
                                            driver.in_black_list > 0 &&
                                            <div className='alert alert-danger super-small-2 p-0 text-center mt-2' style={{fontSize: '8px'}}>
                                                 لیست سیاه
                                            </div>
                                        }
                                        {
                                            driver.in_warning_list > 0 &&
                                            <div className='alert alert-warning super-small-2 p-0 text-center mt-2' style={{fontSize: '8px'}}>
                                                 لیست تذکر
                                            </div>
                                        }
                                    </div>
                                    <div className="col-8">
                                        {driver.full_name}

                                        {driver.work_today ?
                                            <div className='badge badge-info badge-pill bg-warning  mx-2'>
                                                اعلام حضور
                                            </div> : ''
                                        }
                                        {driver.today_shift ?
                                            <div className='badge badge-info badge-pill bg-warning  mx-2'>
                                               شیفت کاری
                                            </div> : ''
                                        }
                                        {driver.rate > 0 && (
                                            <div title={driver.comment}>
                                                {[1, 2, 3, 4, 5].map((star) => (
                                                    <FontAwesomeIcon
                                                        key={star}
                                                        icon={star <= driver.rate ? faSolidStar : faRegularStar}
                                                        style={{ color: "#ffc107", fontSize: 12, marginLeft: 2 }}
                                                    />
                                                ))}
                                                <span className="mx-2 super-small-2">({driver.rate})</span>
                                            </div>
                                        )}
                                        <div className='super-small-2 mt-2'>
                                            <FontAwesomeIcon icon={faTruck}/>
                                            &nbsp;
                                            {driver.car_type}
                                            &nbsp;
                                            <span dangerouslySetInnerHTML={{__html: car_type}}/>
                                        </div>
                                        <div className='mt-2 fw-bold super-small'>
                                            {
                                               driver.cars[0] ? driver.cars[0].plaque : ''
                                            }
                                            {
                                                driver?.cars[0]?.dimensions &&
                                                <span className='badge rounded-pill bg-primary mx-3 px-2'>
                                                ابعاد:
                                                    {
                                                        driver.cars[0] ? driver?.cars[0]?.dimensions?.width : ''
                                                    }
                                                    ,
                                                    {
                                                        driver.cars[0] ? driver?.cars[0]?.dimensions?.height : ''
                                                    }
                                                    ,
                                                    {
                                                        driver.cars[0] ? driver?.cars[0]?.dimensions?.length : ''
                                                    }

                                            </span>
                                            }
                                        </div>

                                    </div>
                                    <div className='col-2 pt-2'>
                                        <a href={'tel:' + driver.phone}>
                                            <FontAwesomeIcon icon={faPhoneAlt} className='text-success '/>
                                        </a>
                                    </div>

                                </div>

                            )

                        })
                    }
                </section>
                {
                    this.state.selected_driver > 0 ?

                        <section className="container-fluid w-100 fixed-bottom max-w-lg bg-opacity-75 bg-blur   bg-dark p-3">
                            <div className="row">
                                <div className='col-12'>
                                    <div className="form-floating">
                                        <textarea className="fo rm-control text-right" placeholder="صافی"
                                                  id="driver_share_description"
                                                  name="driver_share_description"
                                                  value={this.state.driver_share_description}
                                                  onChange={(val) => {
                                                      this.setState({driver_share_description: val.target.value})
                                                  }}
                                        >

                                        </textarea>
                                        <label htmlFor="driver_share_description">توضیحات مربوط به صافی</label>
                                    </div>

                                </div>
                                <div className="col-12 p-3">
                                    <input type="number" className='form-text form-control w-100'
                                           placeholder='صافی راننده (ریال)'
                                           onChange={(val) => {
                                               this.setState({driver_share: val.target.value})
                                           }}
                                    />
                                    <strong className="rtl">
                                        {this.state.driver_share.length > 0 && currencyFormat.format(this.state.driver_share)}
                                        <span>
                                                            &nbsp;
                                            ریال
                                                        </span>
                                    </strong>
                                </div>
                                <div className="col-12">
                                    <button className='btn btn-warning w-100'
                                            onClick={this.onSetDriver}
                                            disabled={this.state.disabled}
                                    >
                                        انتخاب
                                        &nbsp;
                                        {
                                            this.state.selected_driver_name
                                        }
                                    </button>
                                </div>
                            </div>
                        </section> : ''}
            </React.Fragment>
        );
    }

    componentDidMount() {
        const request = {
            expert_drivers: true,
            request_id: this.props.match.params.id
        }
        API.getDrivers(request)
            .then((response) => {
                this.setState({drivers: response.results.drivers, request: response.results.request})

            })
            .catch((error) => {
                //   toast.error(error.response.data.user_message);
            });
    }
}

export default SelectForRequest;